/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_HintInputs */



/**
* | output |
* | --- |
* | "Everything a viewer sees, plus settings, imports, levelling, reviews, images, shared views and the activity log." |
*
* @param {Preset_Manager_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const preset_manager_hint = /** @type {((inputs?: Preset_Manager_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всё, что видит читатель, а также настройки, импорт истории, уровни, проверки, картинки, общие фильтры и журнал активности.")
	return /** @type {LocalizedString} */ ("Everything a viewer sees, plus settings, imports, levelling, reviews, images, shared views and the activity log.")
});